"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./CardWrapper.scss");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CardWrapper =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CardWrapper, _PureComponent);

  function CardWrapper() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CardWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CardWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.isSelectable = function () {
      var onClick = _this.props.onClick;
      return {
        role: 'button',
        tabIndex: 0,
        onClick: onClick // onKeyDown: event => handleEnterEvent(event, onClick),

      };
    };

    return _this;
  }

  _createClass(CardWrapper, [{
    key: "render",
    // eslint-disable-next-line complexity
    value: function render() {
      var _this$props = this.props,
          alignItemsCenter = _this$props.alignItemsCenter,
          selectable = _this$props.selectable,
          children = _this$props.children,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled;
      var className = 'c-CardWrapper';
      var cardWrapperStyle = {};

      if (alignItemsCenter) {
        cardWrapperStyle.textAlign = 'center';
        cardWrapperStyle.alignItems = 'center';
      }

      var activeClassNames = [className, selectable ? "".concat(className, "--selectable") : '', disabled ? "".concat(className, "--disabled") : ''].filter(Boolean).join(' ');
      var selectableProps = selectable ? this.isSelectable() : {};
      return _react2.default.createElement("div", _extends({
        className: activeClassNames,
        style: cardWrapperStyle
      }, selectableProps), children);
    }
  }]);

  return CardWrapper;
}(_react.PureComponent);

CardWrapper.defaultProps = {
  selectable: false,
  onClick: _utils.noop,
  raised: false,
  alignItemsCenter: true,
  disabled: false
};
exports.default = CardWrapper;